export const MAX_UPLOAD_IMAGE_SIZE = 10; //in megabytes
export const MAX_UPLOAD_DOC_FILE_SIZE = 10; //in megabytes
export const FEAT_USE_SOCIAL_URL_ON_START_PROJECT = false;
export const FEAT_USE_BRAND_DOC_ON_START_PROJECT = false;

export const API_URL =
  import.meta.env.VITE_API_URL || 'https://api.rhyme-test.com';

export const VITE_ENVIRONMENT = import.meta.env.VITE_ENVIRONMENT;

export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;

export const generateNoFoundMessage = (name: string) =>
  `No ${name} were found.`;

export const DONT_CHECK_BILLING = import.meta.env.VITE_DONT_CHECK_BILLING;
export const NO_BRAND_WIKI_ERROR = 'no_brand_wiki';
export const FORCE_ADMIN = import.meta.env.VITE_FORCE_ADMIN;
export const FORCE_PROF_UI = import.meta.env.VITE_FORCE_PROF_UI;
export const SHOW_HIDDEN_MENU_ITEMS = import.meta.env
  .VITE_SHOW_HIDDEN_MENU_ITEMS;
